// redux/store.js
import { createStore, applyMiddleware } from 'redux';
import rootReducer from './reducers';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
// Create the Redux store
const store = createStore(rootReducer, applyMiddleware(thunk, createLogger({
    level: 'info',
    predicate: (getState, action) => action.type !== 'UPDATE',
    // collapsed: (getState, action) => action.type === FORM_CHANGE
})));

export default store;
